import React, { useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Document from './Document'
import Survey from './Survey'
import Carousel from 'react-material-ui-carousel'

const useStyles = makeStyles((theme) => ({
    divRootAction: {
        margin: '10px',
        textAlign: 'left',
        '& > svg': {
            margin: '0px 10px 0px 5px',
            fontSize: '20px'
        }
    },
    divContent: {
        borderRadius: '10px',
        padding: '4px 2px',
        textAlign: 'left',
        color: 'var(--color11)',
        '& > div > svg': {
            float: 'left',
            margin: '4px 10px !important'
        },
        '& > span': {
            display: 'table'
        },
        '& > div:last-child': {
            marginBottom: '0px'
        }
    },
    title: {
    },
    divType: {
    },
    divDocument: {
        padding: '8px',
        color: '#ffffff',
        borderRadius: '8px',
        height: '300px',
        margin: '10px 15px 10px 15px',
        fontWeight: 'bold',
        background: 'linear-gradient(#ff010196, #9a0e0e96)',
        boxShadow: '1px 1px 7px 0px #7f7f7f'
    },
    divSurvey: {
        padding: '8px',
        color: '#ffffff',
        background: 'linear-gradient(rgb(111 59 169 / 63%), rgb(79 46 116 / 84%))',
        borderRadius: '8px',
        boxShadow: '1px 1px 7px 0px #7f7f7f',
        margin: '10px 15px 10px 15px',
        opacity: '0.8',
        height: '300px',
        fontWeight: 'bold'
    }
}));

function ActionTake(props) {
    const classes = useStyles();

    const [dataDocument, setDataDocument] = React.useState(null);
    const [dataSurvey, setDataSurvey] = React.useState(null);
    const [showDocument, setShowDocument] = React.useState(null);
    const [showSurvey, setShowSurvey] = React.useState(null);

    useEffect(() => {
        if (props.dataDocument !== null) {
            setDataDocument(props.dataDocument);
        }
    }, [props.dataDocument]);

    useEffect(() => {
        if (props.dataSurvey !== null) {
            setDataSurvey(props.dataSurvey);
        }
    }, [props.dataSurvey]);

    useEffect(() => {
        if (props.showDocument !== null) {
            setShowDocument(props.showDocument);
        }
        if (props.showSurvey !== null) {
            setShowSurvey(props.showSurvey);
        }
    }, [props.showDocument]);

    useEffect(() => {
        if (showDocument !== null && showSurvey !== null) {
            handleIndicatorVisibility();
            triggerInitialIndicator();
        }
    }, [showDocument, showSurvey]);

    const handleIndicatorVisibility = () => {
        // This is to hide the indicator icon below the carousel
        // I had to do this because if you hide only the content, the indicator does not hide itself automatically
        const indicatorButtons = document.querySelectorAll('[aria-label*=carousel]');
        
        // We show first the document and than the survey
        // So the first indicator is for document's content and the second one for the survey's content
        // indicatorButtons[0] = Document indicator
        // indicatorButtons[1] = Survey indicator
        indicatorButtons[0].style.display = showDocument ? 'unset' : 'none';
        indicatorButtons[1].style.display = showSurvey ? 'unset' : 'none';
    }

    const triggerInitialIndicator = () => {
        const indicatorButtons = document.querySelectorAll('[aria-label*=carousel]');

        if (showDocument) {
            indicatorButtons[0].click();
            return;
        }

        if (showSurvey) {
            indicatorButtons[1].click();
        }
    }

    const contentDocumentCarousel = (
        showDocument && <div className={`${classes.divType} ${classes.divDocument}`}>
            <Document handleSelectedPage={props.handleSelectedPage} data={dataDocument} />
        </div>
    )

    const contentSurveyCarousel = (
        showSurvey && <div className={`${classes.divType} ${classes.divSurvey}`}>
            <Survey handleSelectedPage={props.handleSelectedPage} data={dataSurvey} />
        </div>
    )

    return (
        <>
            <div className={classes.divContent}>
                <Carousel
                    autoPlay={false}
                    interval={5000}
                    animation={'slide'}
                    duration={100}
                    navButtonsAlwaysVisible={false}
                    navButtonsAlwaysInvisible={true}
                    swipe={true}
                >
                    {contentDocumentCarousel}
                    {contentSurveyCarousel}
                </Carousel>
            </div>
        </>
    );
}
export default withNamespaces(['home'], { wait: true })(ActionTake);